export default {
    watch: {
        displayModel: {
            handler: function () {
                this.$emit("change", this.displayModel)
            }
        },
        inputModel: {
            handler: function () {
                this.displayModel = this.inputModel;
            }
        }
    }
}